import { Faro } from '@grafana/faro-react';
import { useQuery } from '@tanstack/react-query';
import { createContext, useContext } from 'react';
import { initFaro } from './initializeFaro';

const FaroContext = createContext<Faro | null | undefined>(null);

const useInitFaro = () =>
  useQuery({
    queryKey: ['faro'],
    queryFn: () => initFaro().then((faro) => faro ?? null),
  });

export const FaroProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: faro } = useInitFaro();

  return <FaroContext.Provider value={faro}>{children}</FaroContext.Provider>;
};

export const useFaro = () => useContext(FaroContext);
